import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useEcpProjectsContext} from "../../reactContext/contextCustomHooks/useEcpProjectsContext"
import {useTranslation} from "react-i18next"
import {useForm} from "react-hook-form"
import axios from "axios"
import {API_ECP_PROJECTS} from "../../constants/apiUrls"
import {toast} from "react-toastify"
import useEcpGlossary from "../../swrCustomHooks/useEcpGlossary"
import SortGlossary from "../../tools/SortGlossary"

export default function AddGlossaryTermModalForm({closeModal}) {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {ecpProjectsContext} = useEcpProjectsContext()
    const {ecpGlossary, mutateEcpGlossary,  isLoadingEcpGlossary, isErrorEcpGlossary} = useEcpGlossary(ecpProjectsContext.projectID)
    const {register, handleSubmit, formState: {errors}} = useForm()

    const addGlossaryTerm = (data) => {
        const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}
        let terms = ecpGlossary.glossary
        terms.push(data)
        axios.put(`${API_ECP_PROJECTS}/${ecpProjectsContext.projectID}/glossary`, {glossary: SortGlossary(terms)}, headersRequest)
        .then(() => {
            mutateEcpGlossary()
            closeModal()
            toast.success(t("New term added!"))
        })
        .catch((error) => {
            console.error(`PUT ${API_ECP_PROJECTS}/${ecpProjectsContext.projectID}/glossary :` , error)
            toast.error(t("An error has occurred"))
        })
    }

    return (
        <>
        <form className="glossary-modal-form" onSubmit={handleSubmit(addGlossaryTerm)}>
            <div className="fields">
                <input type="text" id="term-concept" name="term-concept" placeholder={t("Term")} {...register("concept", {required: true})}/>
                <textarea type="text" id="term-definition" name="term-definition" placeholder={t("Definition")} {...register("definition", {required: true})}/>
            </div>
            <div className="actions">
                <button className="cancel-btn" onClick={closeModal}>{t("Cancel")}</button>
                <button className="append-btn">{t("Add")}</button>
            </div>
        </form>
        </>
    )
}